import React from 'react'
import CommonNavbar from '../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../components/CommonFooter/CommonFooter'

const AboutUs = () => {
  return (
    <div>
      <CommonNavbar />

      <section className='py-5 bg-light'>
        <div className='container'>
          {/* Heading */}
          <div className='text-center mb-5'>
            <h2 className='fw-bold text-success display-6'>
              About Farmer’s City
            </h2>
            <p
              className='text-muted lead mt-3 mx-auto'
              style={{ maxWidth: '800px' }}
            >
              At Farmer’s City, we envision a future where every farmer thrives
              in a connected, prosperous, and sustainable global community.
            </p>
          </div>

          {/* Vision & Values */}
          <div className='mb-5'>
            <h3 className=' clr_dark_green fw-bold  mb-3 clr_dark_green'>
              Our Vision
            </h3>
            <p className='text-muted'>
              Our innovative platform empowers farmers and their dependents by
              providing training, certifications, and forward market linkages.
              We aim to revolutionize Indian agriculture through a{' '}
              <span className='fw-semibold text-success'>phygital model</span> —
              integrating physical stores with digital platforms to uplift
              farmers and expand economic opportunities worldwide.
            </p>

            <h4 className='fw-bold mt-4 mb-3 clr_dark_green'>Our Values</h4>
            <ul className='list-unstyled text-muted'>
              <li className='mb-2'>
                Empower farmers & their families through skill development
              </li>
              <li className='mb-2'>
                Connect farmers to essential resources & markets
              </li>
              <li className='mb-2'>
                Enhance efficiency & profitability of farming enterprises
              </li>
              <li className='mb-2'>
                Foster a supportive environment for growth & success
              </li>
            </ul>
          </div>

          {/* Mission */}
          <div>
            <h3 className='fw-bold  mb-3 clr_dark_green'>Our Mission</h3>
            <p className='text-muted'>
              With a strong emphasis on innovation, Farmer’s City strives to
              become the go-to destination for farmers seeking advanced
              technologies, expert guidance, and unparalleled market access. By
              harnessing the power of a{' '}
              <span className='fw-semibold text-success'>phygital model</span>,
              we aim to bridge the gap between traditionally isolated farming
              communities and the vast array of resources available today.
            </p>
            <p className='text-muted'>
              As we continue to evolve, Farmer’s City remains committed to
              delivering exceptional experiences and outcomes for farmers
              everywhere. <span className='fw-semibold'>Join us </span>
              in shaping a brighter tomorrow for the world’s most valuable
              resource:
              <span className='fw-bold text-success'> our farmers</span>.
            </p>
          </div>
        </div>
      </section>

      <CommonFooter />
    </div>
  )
}

export default AboutUs
